import React, { useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles'
import HRRequestListItems from './HRRequestListItems';
import HRRequestFilter from './HRRequestFilter';
import Fab from '@material-ui/core/Fab';
import { isIOS } from '@utils';
import AddIcon from '@material-ui/icons/Add';
import HRRequestDetail from './HRRequestDetail';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        maxWidth: '600px',
        backgroundColor: theme.palette.background.paper,
        padding: '10px',
        marginLeft: 'auto',
        marginRight: 'auto'
    }
}));

function HRRequestList(props) {
    const classes = useStyles();
    const [ filter, setFilter ] = useState({});
    const [openDetail, setOpenDetail] = useState(false);
    const [isiOS, setIsiOS] = useState(isIOS());
    const [dataRow, setDataRow] = useState(null);
    const [reloadFlag, setReloadFlag] = useState(false);

    const triggerReload = () => {
        setReloadFlag(prev => !prev);
    };

    const emptyRequest = {
        hrRequestTypeId: '',
        hrRequest: {
            hrRequestId: 0
        }
    };

    const handleAddButtonClick = () => {
        setDataRow(emptyRequest);
        setOpenDetail(true);
    };

    const handleCloseDetail = () => {
        setOpenDetail(false);
    };

    const handleFilter = (filters) => {
        setFilter({ requestType: filters[0], status: filters[1] });
    }
    
    return (
        <div className={classes.root}>
            <HRRequestFilter handleFilter={handleFilter} />
            <HRRequestListItems filter={filter} isReload={reloadFlag} isHomePage={false} />
            <Fab color="primary" style={{ zIndex: 11001 }} aria-label="add" className={`addButtonFab ${isiOS && "addButtonFabIOS"}`} onClick={handleAddButtonClick} >
                <AddIcon />
            </Fab>
            <HRRequestDetail open={openDetail} onClose={handleCloseDetail} data={emptyRequest} onReload={triggerReload} />
        </div>
    );
}

export default withNamespaces([], { wait: true })(HRRequestList);